import styled from 'styled-components';
import {StrategyPageHeader} from '../Strategy/styles';

/** Título menor no celular — evita 2–3 linhas altas e empurra o hero */
export const PlansPageHeader = styled(StrategyPageHeader)`
    h1 {
        font-size: clamp(1.15rem, 4.6vw, 1.5rem);
        line-height: 1.25;
        gap: 6px;

        @media (min-width: 400px) {
            font-size: clamp(1.2rem, 4.2vw, 1.65rem);
        }

        @media (min-width: 768px) {
            font-size: 32px;
            line-height: 1.2;
            gap: 12px;
        }
    }

    h1 i {
        font-size: clamp(1.35rem, 5vw, 1.65rem);

        @media (min-width: 768px) {
            font-size: 36px;
        }
    }
`;

export const PlansPageInner = styled.div`
    width: 100%;
    max-width: 1100px;
    min-width: 0;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 22px;
    box-sizing: border-box;

    @media (min-width: 480px) {
        gap: 26px;
    }

    @media (min-width: 768px) {
        gap: 40px;
    }
`;

export const PlansBadgeWrap = styled.div`
    text-align: center;
    padding: 0 4px;
    box-sizing: border-box;

    /* Mobile: botão “ponte” — metade no gradiente, metade sobre o fundo escuro da página */
    position: relative;
    z-index: 2;
    margin: 0 0 -22px;

    @media (min-width: 768px) {
        margin: 0 0 22px;
    }
`;

export const PlansBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px 16px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #0a0e27;
    background: linear-gradient(135deg, #f29205 0%, #ffb347 100%);
    box-shadow: 0 4px 16px rgba(242, 146, 5, 0.35);
    max-width: 100%;
    box-sizing: border-box;
    white-space: normal;
    text-align: center;
    line-height: 1.35;
    hyphens: manual;

    @media (max-width: 767px) {
        box-shadow:
            0 6px 22px rgba(242, 146, 5, 0.48),
            0 3px 14px rgba(0, 0, 0, 0.35);
    }

    @media (min-width: 480px) {
        font-size: 12px;
        padding: 6px 14px;
        white-space: nowrap;
    }
`;

export const PlansHero = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    text-align: center;
    max-width: 640px;
    width: 100%;
    min-width: 0;
    margin: 0 auto;
    padding: 0 4px 6px;
    box-sizing: border-box;

    @media (min-width: 480px) {
        padding: 0 10px 8px;
    }
`;

/**
 * Só agrupa ordem no mobile — sem fundo/borda (igual web: texto no fundo escuro já existente da página).
 * Desktop: display:contents.
 */
export const PlansHeroMobileStack = styled.div`
    @media (max-width: 767px) {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 14px;
        margin: 0;
        padding: 30px 0 0;
        box-sizing: border-box;
        background: none;
        border: none;
        box-shadow: none;
    }

    @media (min-width: 768px) {
        display: contents;
    }
`;

export const PlansHeroSubtitleSlot = styled.div`
    margin-top: 0;

    p {
        padding-top: 0;
    }

    @media (min-width: 768px) {
        margin-top: 0;

        p {
            padding-top: 4px;
        }
    }
`;

export const PlansHeroValueSlot = styled.div`
    margin-top: 0;

    ul,
    p {
        margin-top: 0 !important;
    }

    @media (min-width: 768px) {
        margin-top: 0;

        ul,
        p {
            margin-top: 16px !important;
        }
    }
`;

export const PlansSubtitle = styled.p`
    margin: 0;
    padding-top: 4px;
    font-size: 14px;
    line-height: 1.6;
    color: rgba(200, 210, 235, 0.92);
    overflow-wrap: anywhere;
    word-break: break-word;
    hyphens: auto;

    @media (max-width: 767px) {
        line-height: 1.55;
        color: rgba(235, 238, 250, 0.98);
        padding-top: 0;
        margin-top: 16px;
        border-top: none;
    }

    @media (min-width: 480px) {
        font-size: 15px;
    }

    @media (min-width: 768px) {
        font-size: 17px;
        line-height: 1.65;
        border-top: none;
        margin-top: 0;
        padding-top: 4px;
        color: rgba(200, 210, 235, 0.92);
    }
`;

export const PlansValueLine = styled.p`
    margin: 14px 0 0;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.5;
    color: #00d4ff;
    padding: 0 2px;
    overflow-wrap: anywhere;
    word-break: break-word;
    text-wrap: balance;

    @media (min-width: 480px) {
        font-size: 13px;
        margin: 16px 0 0;
    }

    @media (min-width: 768px) {
        font-size: 14px;
    }
`;

/** Uma linha com · (quebra em 2 linhas só se a tela for estreita). Igual ref. mobile e desktop. */
export const PlansValueLineList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0 6px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: baseline;
    gap: 0;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.45;
    color: #7ee8ff;
    text-align: center;
    box-sizing: border-box;
    text-shadow: 0 0 14px rgba(0, 212, 255, 0.28);

    li {
        max-width: 100%;
    }

    li:not(:last-child)::after {
        content: '·';
        margin: 0 0.32rem;
        font-weight: 700;
        opacity: 0.92;
    }

    @media (min-width: 480px) {
        font-size: 12px;
    }

    @media (min-width: 768px) {
        margin: 0;
        font-size: 14px;
        color: #00d4ff;
        text-shadow: none;
        padding: 0 8px;

        li:not(:last-child)::after {
            margin: 0 0.55rem;
        }
    }
`;

export const PlansGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 14px;
    align-items: stretch;
    width: 100%;
    min-width: 0;
    max-width: min(520px, 100%);
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;

    /* Tablet = mesmo arranjo “lado a lado” das telas grandes (img 2) */
    @media (min-width: 768px) {
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        gap: 14px;
        max-width: min(680px, 100%);
        align-items: stretch;
    }

    @media (min-width: 992px) {
        gap: 16px;
        max-width: 640px;
    }
`;

export const PlanCard = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    min-width: 0;
    box-sizing: border-box;
    background: linear-gradient(145deg, rgba(26, 32, 58, 0.95) 0%, rgba(18, 22, 42, 0.98) 100%);
    border: 1px solid rgba(242, 146, 5, 0.22);
    border-radius: 16px;
    padding: 20px 12px 22px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    @media (min-width: 480px) {
        padding: 24px 18px 26px;
    }

    @media (min-width: 768px) {
        padding: 24px 16px 26px;
        border-radius: 18px;
    }

    @media (min-width: 992px) {
        padding: 26px 22px 28px;
    }

    &:hover {
        border-color: rgba(242, 146, 5, 0.4);
        box-shadow: 0 16px 48px rgba(0, 0, 0, 0.45);
    }
`;

export const PlanCardFeatured = styled(PlanCard)`
    border: 1px solid rgba(242, 146, 5, 0.55);
    background: linear-gradient(145deg, rgba(32, 38, 72, 0.98) 0%, rgba(22, 28, 52, 1) 100%);
    box-shadow:
        0 12px 40px rgba(0, 0, 0, 0.4),
        0 0 24px rgba(242, 146, 5, 0.12);
`;

/** Uma coluna: anual primeiro (conversão). Duas colunas (768px+): semestral à esquerda, igual ao desktop */
export const PlanCardSemestralSlot = styled(PlanCard)`
    order: 2;
    padding-top: 28px;

    @media (min-width: 768px) {
        order: 1;
        padding-top: 30px;
    }

    @media (min-width: 992px) {
        padding-top: 32px;
    }
`;

export const PlanCardYearlySlot = styled(PlanCardFeatured)`
    order: 1;
    padding-top: 28px;

    @media (min-width: 768px) {
        order: 2;
        padding-top: 30px;
    }

    @media (min-width: 992px) {
        padding-top: 32px;
    }
`;

export const PlanRibbon = styled.div`
    position: absolute;
    top: 10px;
    right: 0;
    max-width: calc(100% - 16px);
    background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%);
    color: #fff;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 5px 12px 5px 10px;
    border-radius: 6px 0 0 6px;
    box-shadow: -2px 4px 12px rgba(242, 146, 5, 0.4);
    line-height: 1.25;
    text-align: right;
    overflow-wrap: anywhere;

    @media (min-width: 480px) {
        top: 12px;
        font-size: 11px;
        padding: 6px 14px 6px 12px;
        max-width: none;
    }
`;

export const PlanTitle = styled.h2`
    margin: 0 0 8px;
    font-size: clamp(1.05rem, 4.2vw, 1.25rem);
    font-weight: 800;
    color: rgba(245, 248, 255, 0.98);
    letter-spacing: -0.02em;
    line-height: 1.2;
    padding-right: 4px;

    @media (min-width: 768px) {
        font-size: 20px;
    }
`;

export const PlanTagline = styled.p`
    margin: 0 0 18px;
    font-size: 13px;
    line-height: 1.5;
    color: rgba(180, 195, 220, 0.9);
    overflow-wrap: anywhere;

    @media (min-width: 480px) {
        margin: 0 0 20px;
        font-size: 14px;
    }
`;

export const PlanPriceBlock = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 0;
    margin-bottom: 0;
`;

export const PlanPriceRow = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px 8px;
`;

export const PlanCurrency = styled.span`
    font-size: clamp(1rem, 4vw, 1.125rem);
    font-weight: 700;
    color: #f29205;

    @media (min-width: 768px) {
        font-size: 18px;
    }
`;

export const PlanAmount = styled.span`
    font-size: clamp(2rem, 10vw, 2.625rem);
    font-weight: 800;
    line-height: 1;
    color: #ffffff;
    text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);

    /* Duas colunas estreitas: preço um pouco menor que o desktop largo */
    @media (min-width: 768px) and (max-width: 991px) {
        font-size: clamp(1.85rem, 4.2vw, 2.5rem);
    }

    @media (min-width: 992px) {
        font-size: 48px;
    }
`;

export const PlanPeriod = styled.span`
    font-size: clamp(0.875rem, 3.5vw, 1rem);
    font-weight: 600;
    color: rgba(200, 210, 235, 0.85);

    @media (min-width: 768px) {
        font-size: 16px;
    }
`;

export const PlanTotal = styled.p`
    margin: 12px 0 8px;
    font-size: 12px;
    line-height: 1.5;
    color: rgba(160, 175, 205, 0.88);
    overflow-wrap: anywhere;

    @media (min-width: 480px) {
        font-size: 13px;
    }
`;

export const PlanSave = styled.p`
    margin: 8px 0 0;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.45;
    color: #1cc88a;
    overflow-wrap: anywhere;

    @media (min-width: 480px) {
        font-size: 13px;
    }
`;

/** Reserva altura equivalente ao texto verde de economia (2 linhas em telas estreitas) */
export const PlanSaveSpacer = styled.div`
    flex-shrink: 0;
    min-height: 42px;
    margin-top: 8px;
`;

export const PlanBenefits = styled.ul`
    list-style: none;
    margin: 0 0 24px;
    padding: 0;
    text-align: left;
`;

export const PlanBenefitItem = styled.li`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 1.45;
    color: rgba(220, 228, 245, 0.92);

    svg {
        flex-shrink: 0;
        margin-top: 2px;
        color: #f29205;
        font-size: 18px;
    }
`;

export const PlanCtaOutline = styled.div`
    margin-top: auto;
    padding-top: 8px;

    .MuiButton-root {
        width: 100%;
        border-radius: 10px !important;
        border-width: 2px !important;
        border-color: rgba(242, 146, 5, 0.55) !important;
        color: #f29205 !important;
        font-weight: 700 !important;
        padding: 12px 16px !important;
        min-height: 46px !important;
        text-transform: none !important;
        font-size: 14px !important;
        line-height: 1.25 !important;
        white-space: normal !important;

        @media (min-width: 480px) {
            padding: 12px 20px !important;
            min-height: 48px !important;
            font-size: 15px !important;
        }

        &:hover {
            background: rgba(242, 146, 5, 0.12) !important;
            border-color: #f29205 !important;
        }
    }
`;

export const PlanCtaPrimary = styled.div`
    margin-top: auto;
    padding-top: 8px;

    .MuiButton-root {
        width: 100%;
        border-radius: 10px !important;
        border: none !important;
        background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%) !important;
        color: #ffffff !important;
        font-weight: 700 !important;
        padding: 12px 16px !important;
        min-height: 46px !important;
        text-transform: none !important;
        font-size: 14px !important;
        line-height: 1.25 !important;
        white-space: normal !important;
        box-shadow: 0 6px 24px rgba(242, 146, 5, 0.4) !important;

        @media (min-width: 480px) {
            padding: 12px 20px !important;
            min-height: 48px !important;
            font-size: 15px !important;
        }

        &:hover {
            filter: brightness(1.06);
            box-shadow: 0 8px 28px rgba(242, 146, 5, 0.5) !important;
        }
    }
`;

export const PlansSupportBanner = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    text-align: center;
    max-width: min(640px, 100%);
    min-width: 0;
    margin-left: auto;
    margin-right: auto;
    padding: 12px 12px;
    border-radius: 12px;
    background: rgba(0, 212, 255, 0.08);
    border: 1px solid rgba(0, 212, 255, 0.25);
    color: rgba(220, 235, 255, 0.95);
    font-size: 14px;
    line-height: 1.55;
    box-sizing: border-box;
    overflow-wrap: anywhere;

    /* Mobile: como na web — contorno ciano leve, fundo quase igual ao da página (não “card” destacado) */
    @media (max-width: 767px) {
        background: transparent;
        border: 1px solid rgba(0, 212, 255, 0.32);
        border-radius: 10px;
        box-shadow: none;
        padding: 14px 14px 16px;
        max-width: none;
        width: 100%;
    }

    @media (min-width: 480px) {
        padding: 14px 14px;
        font-size: 15px;
    }

    @media (min-width: 480px) and (max-width: 767px) {
        padding: 14px 16px 16px;
    }

    a {
        color: #25d366;
        font-weight: 700;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        flex-wrap: wrap;
        text-align: center;
        max-width: 100%;

        &:hover {
            text-decoration: underline;
        }
    }
`;

export const PlansTrustBlock = styled.div`
    text-align: center;
    padding: 8px 0 0;
    min-width: 0;

    h3 {
        margin: 0 0 12px;
        font-size: 15px;
        font-weight: 700;
        color: rgba(230, 235, 250, 0.95);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        flex-wrap: wrap;
        line-height: 1.3;
        padding: 0 4px;

        @media (min-width: 768px) {
            font-size: 16px;
        }

        svg {
            color: #f29205;
            font-size: 20px;
            flex-shrink: 0;

            @media (min-width: 768px) {
                font-size: 22px;
            }
        }
    }

    p {
        margin: 0 0 16px;
        font-size: 12px;
        line-height: 1.55;
        color: rgba(160, 175, 205, 0.9);
        max-width: min(560px, 100%);
        margin-left: auto;
        margin-right: auto;
        padding: 0 4px;
        overflow-wrap: anywhere;

        @media (min-width: 480px) {
            font-size: 13px;
        }
    }

    img {
        max-width: 100%;
        height: auto;
        border-radius: 8px;
        display: block;
        margin: 0 auto;
    }
`;

export const PlansLegal = styled.div`
    font-size: 11px;
    line-height: 1.65;
    color: rgba(140, 155, 185, 0.88);
    padding-top: 8px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    overflow-wrap: anywhere;
    hyphens: auto;

    @media (min-width: 480px) {
        font-size: 12px;
    }
`;

export const PlansFooterContact = styled.div`
    text-align: center;
    font-size: 13px;
    color: rgba(200, 210, 235, 0.9);
    padding: 0 4px 8px;
    overflow-wrap: anywhere;
    line-height: 1.5;

    @media (min-width: 480px) {
        font-size: 14px;
    }

    a {
        color: rgba(200, 210, 235, 0.95);
        font-weight: 600;
        word-break: break-word;

        &:hover {
            color: #f29205;
        }
    }

    .email-line {
        margin-top: 10px;
        font-size: 12px;
        color: rgba(160, 175, 205, 0.9);
        word-break: break-word;

        @media (min-width: 480px) {
            font-size: 13px;
        }
    }
`;

/**
 * /plans/payment usa DefaultLayout (sem sidebar). Não usar TradingWrapper aqui:
 * largura calc(100% + 3rem) + margens negativas geram scroll horizontal.
 */
export const PlansPaymentLayout = styled.div`
    position: relative;
    align-self: stretch;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    min-height: 100vh;
    min-height: 100dvh;
    background: #0a0e27;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    box-sizing: border-box;
`;

export const PlansPaymentContent = styled.div`
    position: relative;
    z-index: 1;
    flex: 1 0 auto;
    width: 100%;
    min-width: 0;
    display: flex;
    flex-direction: column;
    padding: 34px 14px 32px;
    box-sizing: border-box;

    @media (min-width: 768px) {
        padding: 72px 24px 48px;
    }
`;

/** Coluna central (título + card) — evita título colado na borda e card minúsculo */
export const PaymentContentShell = styled.div`
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    padding: 66px 10px 28px;
    box-sizing: border-box;

    @media (min-width: 768px) {
        padding: 96px 28px 64px;
    }
`;

/** Página /plans/payment — tema escuro */
export const PaymentPageInner = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
`;

export const PaymentCard = styled.div`
    background: linear-gradient(145deg, rgba(26, 32, 58, 0.98) 0%, rgba(18, 22, 42, 1) 100%);
    border: 1px solid rgba(242, 146, 5, 0.28);
    border-radius: 18px;
    padding: 26px 18px 28px;
    box-shadow:
        0 16px 48px rgba(0, 0, 0, 0.45),
        0 0 0 1px rgba(255, 255, 255, 0.04);

    @media (min-width: 768px) {
        padding: 40px 36px 44px;
        border-radius: 20px;
    }

    .MuiFormControl-root {
        width: 100%;
    }

    .MuiFormHelperText-root.Mui-error {
        color: #ff8a8a !important;
        font-size: 12px !important;
        margin-top: 6px !important;
    }

    .MuiOutlinedInput-root fieldset {
        border-width: 1px !important;
        border-color: rgba(242, 146, 5, 0.32) !important;
    }

    .MuiOutlinedInput-root:hover fieldset {
        border-color: rgba(242, 146, 5, 0.5) !important;
    }

    .MuiOutlinedInput-root.Mui-focused fieldset {
        border-color: #00d4ff !important;
    }

    .MuiInputLabel-outlined {
        color: rgba(200, 210, 235, 0.88) !important;
    }

    .MuiOutlinedInput-input {
        color: rgba(230, 235, 250, 0.95) !important;
    }

    @media (max-width: 767px) {
        border-radius: 16px;
        box-shadow:
            0 12px 34px rgba(0, 0, 0, 0.4),
            0 0 0 1px rgba(255, 255, 255, 0.04);

        .MuiInputLabel-outlined {
            font-size: 0.98rem !important;
        }

        .MuiOutlinedInput-root {
            border-radius: 10px !important;
        }
    }
`;

export const PaymentLogoWrap = styled.div`
    text-align: center;
    margin-bottom: 18px;

    img {
        max-width: 124px;
        height: auto;
    }

    @media (min-width: 768px) {
        margin-bottom: 22px;

        img {
            max-width: 148px;
        }
    }
`;

export const PaymentHeading = styled.h2`
    margin: 0 0 12px;
    font-size: 1.1rem;
    font-weight: 800;
    text-align: center;
    color: rgba(245, 248, 255, 0.98);
    letter-spacing: -0.02em;
    line-height: 1.25;

    @media (min-width: 480px) {
        font-size: 1.28rem;
    }

    @media (min-width: 768px) {
        font-size: 1.55rem;
        margin-bottom: 14px;
    }
`;

export const PaymentPlanSummary = styled.p`
    margin: 0 0 24px;
    text-align: center;
    font-size: 0.98rem;
    line-height: 1.55;
    color: rgba(190, 200, 225, 0.95);
    padding: 0 2px;

    @media (min-width: 768px) {
        margin-bottom: 32px;
        font-size: 15px;
        line-height: 1.65;
        padding: 0 4px;
    }
`;

export const PaymentPixFormBlock = styled.div`
    margin-top: 4px;

    .payment-pix-field {
        margin-bottom: 6px;

        .MuiOutlinedInput-root {
            height: 48px !important;
            min-height: 48px !important;
            box-sizing: border-box;
            align-items: center;
        }

        .MuiOutlinedInput-input {
            height: 48px !important;
            padding: 12px 14px !important;
            box-sizing: border-box;
            font-size: 14px !important;
        }

        .MuiInputLabel-outlined {
            font-size: 14px !important;
        }
    }

    .payment-pix-submit {
        margin-top: 18px;
        height: 44px !important;
        min-height: 44px !important;
        max-height: 44px !important;
        padding: 10px 20px !important;
        box-sizing: border-box !important;
        font-size: 14px !important;
        border-radius: 12px !important;

        & > span {
            font-size: 14px !important;
        }
    }

    @media (min-width: 768px) {
        .payment-pix-field {
            margin-bottom: 8px;

            .MuiOutlinedInput-root {
                height: auto !important;
                min-height: 54px !important;
            }

            .MuiOutlinedInput-input {
                height: auto !important;
                padding: 15px 14px !important;
                font-size: 1rem !important;
            }

            .MuiInputLabel-outlined {
                font-size: 1rem !important;
            }
        }

        .payment-pix-submit {
            margin-top: 22px;
            height: auto !important;
            min-height: 54px !important;
            max-height: none !important;
            padding: 16px 24px !important;
            font-size: 1rem !important;
        }
    }
`;

export const PaymentQrSection = styled.div`
    text-align: center;
    color: rgba(230, 235, 250, 0.95);

    h3 {
        margin: 0 0 18px;
        font-size: 15px;
        font-weight: 700;
        line-height: 1.45;
    }

    p {
        margin: 16px 0 8px;
        font-size: 14px;
        color: rgba(200, 210, 235, 0.9);
    }
`;

export const PaymentQrFrame = styled.div`
    display: inline-block;
    padding: 10px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);

    img {
        display: block;
        width: 180px;
        height: 180px;
    }

    @media (min-width: 768px) {
        padding: 12px;

        img {
            width: 200px;
            height: 200px;
        }
    }
`;

export const PaymentStepsList = styled.ol`
    margin: 16px 0 0;
    padding-left: 1.25rem;
    text-align: left;
    color: rgba(200, 210, 235, 0.92);
    font-size: 13px;
    line-height: 1.55;

    li {
        margin-bottom: 6px;
    }
`;

export const PaymentFootnote = styled.p`
    margin: 16px 0 0;
    font-size: 12px;
    line-height: 1.5;
    color: rgba(140, 155, 185, 0.9);
`;

export const PaymentSuccessBlock = styled.div`
    text-align: center;
    padding: 12px 0 8px;

    h3 {
        margin: 0 0 10px;
        font-size: 1.15rem;
        font-weight: 800;
        color: #1cc88a;
    }

    p {
        margin: 0 0 16px;
        font-size: 14px;
        color: rgba(180, 195, 220, 0.9);
    }
`;

export const PaymentInvalidBlock = styled.div`
    text-align: center;
    padding: 8px 0;

    p {
        margin: 0 0 20px;
        font-size: 15px;
        line-height: 1.55;
        color: rgba(200, 210, 235, 0.92);
    }
`;

/** Legado — Payment não usa mais; mantido para compatibilidade */
export const Container = styled.div``;
